/**
 * Advanced Parameters (Cannibalization, Promotions)
 */
import React from 'react';
import { Box, Typography, Paper, Alert } from '@mui/material';

const AdvancedParameters: React.FC = () => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Advanced Parameters
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Configure cannibalization effects and promotion calendars
      </Typography>

      <Alert severity="info" sx={{ mb: 3 }}>
        <strong>Coming Soon:</strong> Cannibalization Matrix and Promotion Calendar configuration will be available in the next release.
      </Alert>

      <Paper sx={{ p: 3, mb: 2 }}>
        <Typography variant="subtitle1" gutterBottom>
          Cannibalization Matrix
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Define how the introduction of new products affects sales of existing products. This helps in accurate forecasting when launching new items.
        </Typography>
      </Paper>

      <Paper sx={{ p: 3 }}>
        <Typography variant="subtitle1" gutterBottom>
          Promotion Calendar
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Schedule promotional events and define their expected impact on sales. This enables the system to account for promotional uplifts in replenishment calculations.
        </Typography>
      </Paper>
    </Box>
  );
};

export default AdvancedParameters;
